import React from "react";
import { Grid, Button, TextField, Paper } from "@material-ui/core";
import { connect } from "react-redux";
import { Add, Delete } from "@material-ui/icons";
import { fundAddCategory, fundAddAttribute } from "store/state/fund";
import styled from "styled-components";
import SubCategory from "./SubCategory";

const AddPaper = styled(Paper)`
  && {
    padding: 5px 0 20px;
    margin-top: 20px;
  }
`;
const AddDiv = styled.div`
  width: 50%;
`;
const AddDivAction = styled.div`
  margin: 15px 0 30px;
`;

class CustomAvps extends React.Component {
  state = {
    add: false,
    name: ""
  };

  handleAddCategory = () => {
    // Trigger update to connected function to add key to avp subcat
    this.setState({
      add: true
    });
  };
  handleCancelCategory = () => {
    // Trigger update to connected function to add key to avp subcat
    this.setState({
      add: false,
      name: ""
    });
  };

  handleSaveCategory = () => {
    const { name } = this.state;
    const { fund } = this.props;

    // Update store with new Category
    const payload = {
      category: "Fund Information",
      subCategory: name,
      fundId: fund.id
    };

    this.props.fundAddCategory(payload);
    // reset state
    this.setState({ name: "", add: false });
  };

  handleChange = ({ target: { name, value } }) => {
    this.setState({
      [name]: value
    });
  };

  render() {
    const { formik, fund, avp } = this.props;
    const { name } = this.state;
    const subCategories = fund.avps["Fund Information"];

    return (
      <Grid container classes={{ container: "FormGroup" }}>
        <Grid className="header_Striped_Left" item xs={6}>
          <h2 id="fund-covenants">AVPS</h2>
        </Grid>
        <Grid item xs={12} className="row">
          {Object.keys(subCategories).map(keyName => {
            if (keyName === "Details") {
              return null;
            }
            return (
              <SubCategory
                key={keyName}
                subCategoryName={keyName}
                data={subCategories[keyName]}
                formik={formik}
                avp={avp}
                fund={fund}
              />
            );
          })}
          {!this.state.add && (
            <AddDivAction>
              <Button
                variant="raised"
                color="secondary"
                onClick={this.handleAddCategory}
              >
                <Add />
                Add Category
              </Button>
            </AddDivAction>
          )}
          {this.state.add && (
            <AddDiv className="addSection">
              <AddPaper>
                <h4 className="avps_FieldsTextarea">Add Category</h4>
                <TextField
                  label="category name"
                  className="avps_FieldsTextarea avp-item"
                  type="text"
                  margin="normal"
                  value={name}
                  onChange={this.handleChange}
                  // eslint-disable-next-line
                  name={`name`}
                />
                <div className="avps_FieldsTextarea">
                  <Button
                    disabled={!name}
                    variant="raised"
                    color="primary"
                    onClick={this.handleSaveCategory}
                  >
                    <Add />
                    Add
                  </Button>
                  <Button variant="raised" onClick={this.handleCancelCategory}>
                    <Delete />
                    Cancel
                  </Button>
                </div>
              </AddPaper>
            </AddDiv>
          )}
        </Grid>
      </Grid>
    );
  }
}

export default connect(
  null,
  { fundAddCategory, fundAddAttribute }
)(CustomAvps);
